import { getFlagName, pwaFlags } from "../util/flags.js";
import { useRef, useSyncExternalStore } from "react";

//#region src/hooks/use-pwa-flags.ts
const usePwaFlags = (pwaId) => {
	const latestValue = useRef(void 0);
	const localStore = {
		getSnapshot: () => {
			try {
				const pwaFlagSet = pwaFlags.reduce((acc, flag) => {
					acc[flag] = Boolean(localStorage.getItem(getFlagName(pwaId, flag)));
					return acc;
				}, {});
				if (JSON.stringify(pwaFlagSet) === JSON.stringify(latestValue.current)) return latestValue.current;
				latestValue.current = pwaFlagSet;
				return pwaFlagSet;
			} catch (error) {
				console.error(error);
				return pwaFlags.reduce((acc, flag) => {
					acc[flag] = false;
					return acc;
				}, {});
			}
		},
		subscribe: (listener) => {
			window.addEventListener("storage", listener);
			return () => void window.removeEventListener("storage", listener);
		}
	};
	const flags = useSyncExternalStore(localStore.subscribe, localStore.getSnapshot);
	const setFlag = (flag, value) => {
		try {
			const flagName = getFlagName(pwaId, flag);
			localStorage.setItem(flagName, String(value));
			window.dispatchEvent(new StorageEvent("storage", {
				key: flagName,
				newValue: String(value)
			}));
		} catch (error) {
			console.error(error);
		}
	};
	return {
		flags,
		setFlag
	};
};

//#endregion
export { usePwaFlags };